import React, { PureComponent } from "react"
import withStyles from "@mui/styles/withStyles"
import { connect } from "react-redux"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import { productTagsTypes } from "../../../../../utils/productTagsUtils"
import Button from "@mui/material/Button"
import {
    showProductsTagsList,
    showProductTagEdit
} from "../../../../../actions/ProductsTags/ProductsTags"
import {
    getProductTag
} from "../../../../../reducers/ProductsTags/ProductsTags"

const styles = {
    container: {
        padding: 20
    },
    closeWindow: {
        textAlign: "right"
    },
    subContainer: {
        marginLeft: 15,
        marginBottom: 15,
        width: 200
    },
    titleLabelContainer: {
        fontSize: "1rem",
        transform: "matrix(0.75, 0, 0, 0.75, 0, 1.5 )",
        opacity: "0.54",
        transformOrigin: "0px 0px"
    },
    editBtn: {
        textAlign: "right",
        marginRight: 15
    },
    infoContainer: {
        display: "flex"
    }
}

export class ProductTagRead extends PureComponent {

    _onClose = () => {
        const { showProductsTagsList } = this.props

        showProductsTagsList()
    }

    _onEditClick = () => {
        const {
            showProductTagEdit,
            productTag
        } = this.props

        showProductTagEdit(productTag.objectId, "edit")
    }

    render() {
        const {
            classes,
            productTag
        } = this.props
        const labelType = productTag && productTagsTypes.find(el => el.value === productTag.type)
            ? productTagsTypes.find(el => el.value === productTag.type).label
            : ""

        return (
            <div className={classes.container}>
                <div className={classes.closeWindow}>
                    <IconButton aria-label="Fermer" onClick={this._onClose} size="large">
                        <CloseIcon />
                    </IconButton>
                </div>
                <div className={classes.infoContainer}>
                    <div className={classes.subContainer}>
                        <div className={classes.titleLabelContainer}>
                            Nom
                        </div>
                        <div>
                            {productTag && productTag.name}
                        </div>
                    </div>
                    <div className={classes.subContainer}>
                        <div className={classes.titleLabelContainer}>
                            Type
                        </div>
                        <div>
                            {
                                productTag &&
                                labelType
                            }
                        </div>
                    </div>
                </div>
                <div className={classes.editBtn}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this._onEditClick}
                    >
                        Editer
                    </Button>
                </div>
            </div>
        )
    }
}

const ProductTagReadStyled = withStyles(styles)(ProductTagRead)

export default connect((state, props) => {
    const { params: { id } } = props
    const productTag = id ? getProductTag(state, id) : null

    return {
        productTag: productTag,
        types: state.productsTags.types
    }
}, {
    showProductTagEdit,
    showProductsTagsList
})(ProductTagReadStyled)
